import React, { useEffect } from "react";
import styles from "./AddDealerBase.less";
import Button from "~/shared/ui/Fields/Button";
import { getAddDealerFields } from "./options";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import Input from "~/shared/ui/Fields/Input";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { validateInn } from "../requests/dadata";
import useAddNewDealer from "../hook/useAddNewDealer";

const AddDealerBase = ({ DealerId }) => {
  const { t } = useTranslation();
  const formResolver = yup.object().shape({
    dealerName: yup.string().nullable().required(t("validation.required")),
    code: yup.string().nullable().required(t("validation.required")),
    inn: yup.string().nullable().required(t("validation.required")),
  });
  const {
    mutate: addDealerMutate,
    isLoading,
    error,
  } = useAddNewDealer("newDealer");
  const { control, handleSubmit, errors, watch, setError, clearErrors } =
    useForm({
      defaultValues: {
        dealerName: "",
        code: "",
        inn: "",
      },
      resolver: yupResolver(formResolver),
    });

  useEffect(() => {
    let valueInn = watch("inn");
    if (valueInn && valueInn.length >= 10) {
      const isValid = async () => {
        try {
          let data = await validateInn(valueInn);
          if (!data) {
            setError("inn", { type: "manual", message: "Некорректный инн" });
          } else {
            clearErrors("inn");
          }
        } catch (e) {
          setError("inn", { type: "server", message: "Ошибка проверки инн" });
        }
      };
      isValid();
    } else {
      clearErrors("inn");
    }
  }, [watch("inn")]);

  const onSubmit = (data) => {
    addDealerMutate(data);
  };

  return (
    <div className={styles.wrapperAdd}>
      <div className={styles.titleAdd}>
        <span>Основная информация</span>
      </div>
      <form className={styles.formAddDealer} onSubmit={handleSubmit(onSubmit)}>
        {getAddDealerFields(t).map(({ name, label }) => {
          return (
            <Input
              key={name}
              customClassName={styles.inputAdd}
              control={control}
              name={name}
              label={label}
              error={errors[name]?.message ?? ""}
            />
          );
        })}
        <Button
          txtBtn={"Сохранить изменения"}
          orange
          isForm
          customClassName={styles.addDealer}
        />
      </form>
    </div>
  );
};
export default AddDealerBase;
